<template>
    <div>
        <!-- Personalised header -->
        <section>
            <div class="centric-hold-80">
                <div class="wrapp-rt2">
                    <div class="row sub-header-hold">
                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                        <div class="date-time-hold-head">
                        <span>
                            <!-- <img :src="getImgUrl(businessLogo)" :title="businessName" :alt="businessName" class="dr-logo" /> -->
                            <img :src="getImgUrl(businessLogo)" class="dr-logo" />
                        </span>
                        <!-- <h2>{{businessName}}</h2>--></div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                        <div class="date-time-hold-head doctor-detail"><img :src="getImgUrlProfile(providerPic)" class="imghold"/><h5 class="provider-title">{{providerTitle}} {{providerFirstName}} {{providerLastName}}</h5></div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 pull-right">
                        <div class="date-time-hold-head no-border"><span><i class="material-icons">call</i></span><h4 v-html="generateContactNumbers(clinicContactNumbers)"></h4></div></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Personalised header ends -->
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: "PersonalisedHeader",
  computed: {
    ...mapGetters([
        'tenantId',
        'protocol',
        'subDomain',
        'businessId',
        'businessLogo',
        'businessName',    
        'businessType',
        'businessWebsiteUrl',
        'providerTitle',
        'providerFirstName',
        'providerLastName',
        'providerId',
        'providerPic',
        'providerColorCode',
        'providerPhone',
        'locationName',
        'clinicContactNumbers',
        'clinicAddress',
        'locationId',
        'locationTz',
        'mapUrlEmbedded',
        'clientTz',
        'loading',
        'loadingMessage',
        'error',
        'errorMessage'
    ])
  },
  methods: {
    getImgUrl(val) {
        //console.log(process.env.VUE_APP_STATIC_FILES + " static files path - clinic " + val);
        var images = "";
        if(val){
            images = process.env.VUE_APP_STATIC_FILES + "/"+ this.$store.getters.tenantId +"/images/logo/" + val;
            localStorage.setItem("businesslogourl",images);
            return images;
        }else{
            images = "https://s3.amazonaws.com/genamet-static-uploads/common/genamet-no-logo.png";
            return images;
        }        
    },
    getImgUrlProfile(val) {
        //console.log(process.env.VUE_APP_STATIC_FILES + " static files path - my photo " + val);
        var images = "";
        if(val){
            images = process.env.VUE_APP_STATIC_FILES + "/"+ this.$store.getters.tenantId +"/images/profile_photo/" + val;
            return images;
        }else{
            images = "https://s3.amazonaws.com/genamet-static-uploads/common/noprofilephoto.jpg";
            return images;
        }         
    },
    getUrlMap(val) 
    { 
        var url = this.getImgUrlProfile(val);
        return { 'background-image': 'url("' + url + '") ' } 
    },
    generateContactNumbers(val){
        console.log(val + "yoyo")
        if( typeof val !== 'undefined' && val.trim() != ""){
            let contactArray = val.split(",");
            let phoneConcat = "";
            if(Array.isArray(contactArray) === 'undefined'){
                return '<a href="tel:' + val + '">'+ val +'</a>';
            }else{
                let index = 0;
                for (index = 0; index < contactArray.length; ++index) {
                    if(index == 0){
                        phoneConcat += '<a href="tel:' + contactArray[index] + '">'+ contactArray[index] +'</a>';
                    }else{
                        phoneConcat += '<br /><a href="tel:' + contactArray[index] + '">'+ contactArray[index] +'</a>';
                    }
                }
                return phoneConcat;
            }  
        }else{
            return "";
        }
              
    }
  },
  created(){
      if(localStorage.businesslogourl){
          localStorage.removeItem("businesslogourl");
      }
  }
};
</script>

<style>
</style>
